
<div class="main">
    <div class="img-container">
        <img class="img-banner" src="https://statics.losan.com/sites/default/files/gadget_galeria_files/cabecera_1020x900_infantil.jpg">
        <h1 class="img-text">Ropa para los más chiquitos</h1>
    </div>
    <div class="d-flex background-secondary banner justify-content-center">
            <h3 class="banner-text">Tenemos lo mejor para vos!</h3>
            <button class="btn bg-primary button-banner" (click)="pushToProducts()">Mirá todos nuestros productos 💣</button>
    </div>
    <div class="mt-3 container">
        <h1>Destacados</h1>
        <hr>
        <app-trending-products></app-trending-products>
    </div>
</div>